import { render } from "./AssignmentEditReview.vue?vue&type=template&id=38342fbb&ts=true"
import script from "./AssignmentEditReview.vue?vue&type=script&lang=ts"
export * from "./AssignmentEditReview.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__